import reducer from './reducers/index';
import routes from '../routes'
import * as trainingMasterModuleActions from './actions';
import * as trainingMasterModuleOperations from './operations';
import * as trainingMasterModuleSelectors from './selectors';

export {
    trainingMasterModuleOperations,
    trainingMasterModuleSelectors,
    trainingMasterModuleActions,
};

export default {
    reducer,
    routes
};
